import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "h-[calc(100vh-122px)] md:h-[calc(100vh-112px)] overflow-y-auto" }
const _hoisted_2 = {
  class: "m-4 p-4",
  style: {"border":"2px solid #d1d5db","border-radius":"10px"}
}
const _hoisted_3 = { class: "hidden md:block md:w-[680px]" }
const _hoisted_4 = { class: "w-full md:hidden" }
const _hoisted_5 = { class: "flex flex-col col-span-1 justify-start items-start" }
const _hoisted_6 = {
  class: "m-4 p-4",
  style: {"border":"2px solid #d1d5db","border-radius":"10px"}
}
const _hoisted_7 = { class: "hidden md:block md:w-[680px]" }
const _hoisted_8 = { class: "w-full md:hidden" }
const _hoisted_9 = { class: "flex flex-col col-span-1 justify-start items-start" }
const _hoisted_10 = {
  class: "m-4 p-4",
  style: {"border":"2px solid #d1d5db","border-radius":"10px"}
}
const _hoisted_11 = { class: "hidden md:block md:w-[680px]" }
const _hoisted_12 = { class: "flex flex-grow items-center" }
const _hoisted_13 = { class: "ml-4 w-12" }
const _hoisted_14 = { class: "w-full md:hidden" }
const _hoisted_15 = { class: "flex flex-grow items-center" }
const _hoisted_16 = { class: "ml-4 w-12" }
const _hoisted_17 = { class: "flex flex-col col-span-1 justify-start items-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Minus = _resolveComponent("Minus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_mian = _resolveComponent("el-mian")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_container, { style: {"height":"calc(100vh - 52px)"} }, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, { style: {"height":"0px"} }),
      _createVNode(_component_el_mian, { style: {"padding-bottom":"20px"} }, {
        default: _withCtx(() => [
          _cache[31] || (_cache[31] = _createElementVNode("div", { class: "custom-title flex items-center md:h-[40px]" }, [
            _createElementVNode("span", null, "環境設定")
          ], -1)),
          _createElementVNode("div", _hoisted_1, [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
              _cache[23] || (_cache[23] = _createElementVNode("div", { class: "flex flex-col md:flex-row h-[40px]" }, "メール通知設定：", -1)),
              _createVNode(_component_el_form, {
                model: _ctx.emailSettings,
                rules: _ctx.emailRules,
                ref: "emailFormRef",
                "label-width": "auto"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_el_form_item, {
                      label: "メールアカウント：",
                      prop: "emailAccount"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.emailSettings.emailAccount,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.emailSettings.emailAccount) = $event)),
                          autocomplete: "off",
                          placeholder: "メールアカウントを入力してください"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "メールパスワード：",
                      prop: "emailPassword"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.emailSettings.emailPassword,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.emailSettings.emailPassword) = $event)),
                          autocomplete: "off",
                          placeholder: "メールパスワードを入力してください"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "メールサーバーURL：",
                      prop: "emailServerUrl"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.emailSettings.emailServerUrl,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.emailSettings.emailServerUrl) = $event)),
                          autocomplete: "off",
                          placeholder: "メールサーバーURLを入力してください"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "メールサーバーポート：",
                      prop: "emailServerPort"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.emailSettings.emailServerPort,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.emailSettings.emailServerPort) = $event)),
                          min: 1,
                          max: 65535,
                          autocomplete: "off",
                          placeholder: "メールサーバーポートを入力してください"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "送信者：",
                      prop: "emailSender"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.emailSettings.emailSender,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.emailSettings.emailSender) = $event)),
                          autocomplete: "off",
                          placeholder: "送信者を入力してください"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "タイトル：",
                      prop: "emailSubject"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.emailSettings.emailSubject,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.emailSettings.emailSubject) = $event)),
                          autocomplete: "off",
                          placeholder: "メールタイトルを入力してください"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "内容：",
                      prop: "emailText"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.emailSettings.emailText,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.emailSettings.emailText) = $event)),
                          autocomplete: "off",
                          type: "textarea",
                          autosize: "",
                          placeholder: "メール内容を入力してください"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_el_form_item, { prop: "emailAccount" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.emailSettings.emailAccount,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.emailSettings.emailAccount) = $event)),
                          autocomplete: "off",
                          placeholder: "メールアカウントを入力してください"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { prop: "emailPassword" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.emailSettings.emailPassword,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.emailSettings.emailPassword) = $event)),
                          autocomplete: "off",
                          placeholder: "メールパスワードを入力してください"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { prop: "emailServerUrl" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.emailSettings.emailServerUrl,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.emailSettings.emailServerUrl) = $event)),
                          autocomplete: "off",
                          placeholder: "メールサーバーURLを入力してください"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { prop: "emailServerPort" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.emailSettings.emailServerPort,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.emailSettings.emailServerPort) = $event)),
                          min: 1,
                          max: 65535,
                          autocomplete: "off",
                          placeholder: "メールサーバーポートを入力してください"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { prop: "emailSender" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.emailSettings.emailSender,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.emailSettings.emailSender) = $event)),
                          autocomplete: "off",
                          placeholder: "送信者を入力してください"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { prop: "emailSubject" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.emailSettings.emailSubject,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.emailSettings.emailSubject) = $event)),
                          autocomplete: "off",
                          placeholder: "メールタイトルを入力してください"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { prop: "emailText" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.emailSettings.emailText,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.emailSettings.emailText) = $event)),
                          autocomplete: "off",
                          type: "textarea",
                          autosize: "",
                          placeholder: "メール内容を入力してください"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["model", "rules"]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_el_button, {
                  type: "info",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.handleSaveEmailButton(_ctx.emailFormRef)))
                }, {
                  default: _withCtx(() => _cache[21] || (_cache[21] = [
                    _createTextVNode("保存")
                  ])),
                  _: 1
                }),
                _cache[22] || (_cache[22] = _createElementVNode("span", { class: "text-gray-900 text-sm" }, "※メール関連設定保存", -1))
              ])
            ])), [
              [_directive_loading, _ctx.loading1]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
              _cache[26] || (_cache[26] = _createElementVNode("div", { class: "flex flex-col md:flex-row h-[40px]" }, "アラートメッセージ設定：", -1)),
              _createVNode(_component_el_form, {
                model: _ctx.notificationSettings,
                rules: _ctx.notificationRules,
                ref: "notificationFormRef",
                "label-width": "auto"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_el_form_item, {
                      label: "タイトル：",
                      prop: "notificationSubject"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.notificationSettings.notificationSubject,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.notificationSettings.notificationSubject) = $event)),
                          autocomplete: "off",
                          placeholder: "アラートタイトルを入力してください"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "内容：",
                      prop: "notificationText"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.notificationSettings.notificationText,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.notificationSettings.notificationText) = $event)),
                          autocomplete: "off",
                          type: "textarea",
                          autosize: "",
                          placeholder: "アラート内容を入力してください"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_el_form_item, { prop: "notificationSubject" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.notificationSettings.notificationSubject,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.notificationSettings.notificationSubject) = $event)),
                          autocomplete: "off",
                          placeholder: "アラートタイトルを入力してください"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { prop: "notificationText" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.notificationSettings.notificationText,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.notificationSettings.notificationText) = $event)),
                          autocomplete: "off",
                          type: "textarea",
                          autosize: "",
                          placeholder: "アラート内容を入力してください"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["model", "rules"]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_el_button, {
                  type: "info",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.handleSaveNotificationButton(_ctx.notificationFormRef)))
                }, {
                  default: _withCtx(() => _cache[24] || (_cache[24] = [
                    _createTextVNode("保存")
                  ])),
                  _: 1
                }),
                _cache[25] || (_cache[25] = _createElementVNode("span", { class: "text-gray-900 text-sm" }, "※アラートメッセージ関連設定保存", -1))
              ])
            ])), [
              [_directive_loading, _ctx.loading2]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
              _cache[30] || (_cache[30] = _createElementVNode("div", { class: "flex flex-col md:flex-row h-[40px]" }, "JANCODE設定：", -1)),
              _createVNode(_component_el_form, {
                model: _ctx.jancodeSettings,
                rules: _ctx.jancodeRules,
                ref: "jancodeFormRef",
                "label-width": "auto"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.jancodeSettings), (key, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        (_ctx.showJancodeSettings[index])
                          ? (_openBlock(), _createBlock(_component_el_form_item, {
                              key: 0,
                              label: index === 0 ? 'AppId' : '\u00A0',
                              prop: key
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_12, [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.jancodeSettings[key],
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.jancodeSettings[key]) = $event),
                                    autocomplete: "off",
                                    placeholder: "AppIdを入力してください"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.jancodeCount[`count${index}`]), 1),
                                  (_ctx.showJancodeSettings.filter(value => value === true).length > 1)
                                    ? (_openBlock(), _createBlock(_component_el_button, {
                                        key: 0,
                                        class: "ml-4",
                                        onClick: ($event: any) => (_ctx.handleDelJancodeButton(index)),
                                        circle: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Minus)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 2
                            }, 1032, ["label", "prop"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.jancodeSettings), (key, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        (_ctx.showJancodeSettings[index])
                          ? (_openBlock(), _createBlock(_component_el_form_item, {
                              key: 0,
                              prop: key
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_15, [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.jancodeSettings[key],
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.jancodeSettings[key]) = $event),
                                    autocomplete: "off",
                                    placeholder: "AppIdを入力してください"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.jancodeCount[`count${index}`]), 1),
                                  (_ctx.showJancodeSettings.filter(value => value === true).length > 1)
                                    ? (_openBlock(), _createBlock(_component_el_button, {
                                        key: 0,
                                        class: "ml-4",
                                        onClick: ($event: any) => (_ctx.handleDelJancodeButton(index)),
                                        circle: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Minus)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 2
                            }, 1032, ["prop"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ])
                ]),
                _: 1
              }, 8, ["model", "rules"]),
              (_ctx.showJancodeSettings.filter(value => value === true).length < 10)
                ? (_openBlock(), _createBlock(_component_el_link, {
                    key: 0,
                    type: "primary",
                    class: "mb-4",
                    onClick: _ctx.handleAddJancodeButton
                  }, {
                    default: _withCtx(() => _cache[27] || (_cache[27] = [
                      _createTextVNode(" AppId追加 ")
                    ])),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_el_button, {
                  type: "info",
                  onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.handleSaveJancodeButton(_ctx.jancodeFormRef)))
                }, {
                  default: _withCtx(() => _cache[28] || (_cache[28] = [
                    _createTextVNode("保存")
                  ])),
                  _: 1
                }),
                _cache[29] || (_cache[29] = _createElementVNode("span", { class: "text-gray-900 text-sm" }, "※JANCODE関連設定保存", -1))
              ])
            ])), [
              [_directive_loading, _ctx.loading4]
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}